/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { imageService } from '../../ServiceFactory';
import { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';
import { ImageSizes } from '../../shared/services/Image.service';
import { Box, Grid } from '@mui/material';

const useStyles = makeStyles(() =>
	createStyles({
		image: {
			width: '100px',
			borderRadius: '4px'
		}
	})
);

export interface Props {
	images: ClientMediaItem[];
	leftGalleryBoxPadding: string;
}

function ImageGallery(props: Props): JSX.Element {
	const classes = useStyles();
	const { images, leftGalleryBoxPadding } = props;
	return (
		<Box pl={leftGalleryBoxPadding} pt={0.5}>
			<Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
				{images.map(image => {
					const imageUrl =
						image !== undefined && image !== null
							? imageService().getAvailableImageUrl(image, ImageSizes.THUMBNAIL)
							: '';
					return (
						<Grid key={image.id} item>
							<a href={imageService().getAvailableImageUrl(image, ImageSizes.ORIGINAL)} target="blank">
								<img src={imageUrl} alt="Snow" className={classes.image} />
							</a>
						</Grid>
					);
				})}
			</Grid>
		</Box>
	);
}
export default ImageGallery;
